import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getEventKeyMappingsDatatable,
  getEventKeyMappingById,
  editEventKeyMapping,
  changeEventKeyMappingPublishingState,
} from './thunks';
import { EventKeyMappingsState } from './types';

export const name = 'eventKeyMappings';

const initialState: EventKeyMappingsState = {
  datatable: {
    data: null,
    status: 'idle',
  },
  eventKeyMappingById: {
    data: null,
    status: 'idle',
  },
  editEventKeyMapping: {
    status: 'idle',
  },
  changeEventKeyMappingPublishingState: {
    status: 'idle',
  },
};

export const getEventKeyMappingsDatatableAsync = createAsyncThunk(
  name + '/getEventKeyMappingsDatatable',
  getEventKeyMappingsDatatable
);

export const getEventKeyMappingByIdAsync = createAsyncThunk(
  name + '/getEventKeyMappingById',
  getEventKeyMappingById
);

export const editEventKeyMappingAsync = createAsyncThunk(
  name + '/editEventKeyMapping',
  editEventKeyMapping
);

export const changeEventKeyMappingPublishingStateAsync = createAsyncThunk(
  name + '/changeEventKeyMappingPublishingState',
  changeEventKeyMappingPublishingState
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEventKeyMappingsDatatableAsync.pending, (state) => {
        state.datatable.status = 'loading';
      })
      .addCase(getEventKeyMappingsDatatableAsync.fulfilled, (state, action) => {
        state.datatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getEventKeyMappingsDatatableAsync.rejected, (state) => {
        state.datatable.status = 'failed';
      })
      .addCase(getEventKeyMappingByIdAsync.pending, (state) => {
        state.eventKeyMappingById.status = 'loading';
      })
      .addCase(getEventKeyMappingByIdAsync.fulfilled, (state, action) => {
        state.eventKeyMappingById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getEventKeyMappingByIdAsync.rejected, (state) => {
        state.eventKeyMappingById.status = 'failed';
      })
      .addCase(editEventKeyMappingAsync.pending, (state) => {
        state.editEventKeyMapping.status = 'loading';
      })
      .addCase(editEventKeyMappingAsync.fulfilled, (state) => {
        state.editEventKeyMapping.status = 'idle';
      })
      .addCase(editEventKeyMappingAsync.rejected, (state) => {
        state.editEventKeyMapping.status = 'failed';
      })
      .addCase(changeEventKeyMappingPublishingStateAsync.pending, (state) => {
        state.changeEventKeyMappingPublishingState.status = 'loading';
      })
      .addCase(changeEventKeyMappingPublishingStateAsync.fulfilled, (state) => {
        state.changeEventKeyMappingPublishingState.status = 'idle';
      })
      .addCase(changeEventKeyMappingPublishingStateAsync.rejected, (state) => {
        state.changeEventKeyMappingPublishingState.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
